app.EmployerTerms = (
    function () {

        var terms = {

            //Index Page
            Index: function () {
                if (window.location.href.indexOf("#warn") > -1) {

                    $("#termsModal").modal("show");
                }
            }
        };

        return terms;
    }()
);